import { ObservableArray, View } from "binder"
import { StartupNotificationsViewModel, notification } from "./startupNotifications-viewModel"

export class StartupNotificationsView extends View<StartupNotificationsViewModel>{
    GetViewUniqueId(): string {
        return "V-F5B37583-0E9C-4732-9B5E-2DADD803F250"
    }
    loadHtml(): string {
        let element = require('./startupNotifications.html').default;
        let style = require('./startupNotifications.less');
        return element;
    }
    constructor() {
       super();
    }
    public set items(v: ObservableArray<notification>) { this._items = v; } public get items(): ObservableArray<notification> { return this._items;} private _items: ObservableArray<notification>;
}
